module.exports = __webpack_public_path__ + "img/internet-card-header.fd726d59.jpg";